// import { ProductKey } from '@atlassiansox/asc-product-catalog';
// import {
//   PricingCalculation,
//   PricingPeriod
// } from '@atlassian/bxp-product-pricing';
//
// import { usePricingCalculator } from '../contexts';
// import { AsyncResult, useAsync } from './use-async';
//
// export type PricingEditionResult = PricingCalculation[] & {
//   readonly units: number;
//   readonly period: PricingPeriod;
// };
//
// export function usePricingEdition(
//   productKeys: ProductKey[],
//   units: number,
//   period: PricingPeriod,
//   currencyIsoCode: string
// ): AsyncResult<PricingEditionResult> {
//   const calculator = usePricingCalculator();
//
//   return useAsync(async () => {
//     const pricing = await Promise.all(
//       productKeys.map((productKey) => {
//         return calculator.calculatePrice({
//           productKey,
//           units,
//           period,
//           currencyIsoCode
//         });
//       })
//     );
//
//     return {
//       ...pricing,
//       units,
//       period
//     };
//   }, [units, period, currencyIsoCode]);
// }
